export default __webpack_public_path__ + "static/media/Petrocks.a26c87aa.png";